import { useState } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
import MessageTextContainer from "../MessageTextContainer";
import "./AssistantMessage.scss";

const AssistantMessage = ({ content }) => {
  const [expanded, setExpanded] = useState(false);

  if (!content || content.trim() === "") {
    return null;
  }

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="assistant_message">
      <div
        className="assistant_message_header"
        onClick={handleToggle}
      >
        <div className="assistant_message_title">
          <span className="assistant_icon">💬</span>
          <span className="assistant_label">Assistant</span>
        </div>
        <div className="assistant_message_toggle">
          {expanded ? (
            <ChevronUpIcon size={18} />
          ) : (
            <ChevronDownIcon size={18} />
          )}
        </div>
      </div>
      <div
        className={`assistant_message_content ${
          expanded ? "" : "line-clamp-3"
        }`}
      >
        <MessageTextContainer>{content}</MessageTextContainer>
      </div>
    </div>
  );
};

export default AssistantMessage;
